export const nasType = [
  //changed value from MTK to MKT
  // Sailaja sorting the Optical network -> Add NAS-> NAS Type Dropdown data as alphabetical order on 24th March 2023

  {
    id: "ATL",
    name: "Alcatel",
  },
  {
    id: "CIS",
    name: "Cisco",
  },
  {
    id: "HB",
    name: "HB",
  },
  {
    id: "HUW",
    name: "Huawei",
  },
  {
    id: "JUN",
    name: "Juniper",
  },
  {
    id: "MKT",
    name: "Mikrotik",
  },
  {
    id: "VBNG",
    name: "Vbng-Soft",
  },
]

export const statusType = [
  {
    id: "ACT",
    name: "Active",
  },
  {
    id: "IN",
    name: "Inactive",
  },
]